/* global VXConfig */
import React                                                           from 'react';
import PropTypes                                                       from "prop-types";
import Flux                                                            from '../../flux/Flux';
import Breadcrumb                                                      from '../Breadcrumb';
import Headline                                                        from '../SimpleElements/Headline';
import CamsSeoTeaser                                                   from './CamsSeoTeaser';
import CamsGrid                                                        from './CamsGrid';
import CamsSeoFooter                                                   from './CamsSeoFooter';
import Translations                                                    from '../../utils/Translations';
import {generateModelsV3Filter, getDefaultFilter, setActiveFilterTags} from './CamsHelper';
import ExtendedSorter                                                  from '../SimpleElements/ExtendedSorter.js';
import {ModalBoxEnum, openModalBox}                                    from '../ModalBox/ModalBoxFactory.js';
import Filter                                                          from '../Filter/Filter';
import TopFilterContainer                                              from '../Filter/TopFilterContainer.js';
import {
    CAMS,
    getActiveFilter,
    getBaseUrl,
    getFilter,
    getFilterCount,
    getFilterFromUrl,
    getOrderParam,
    getSeo,
    getTopFilter,
    setFilterParam,
    setOrderParam,
}                                                                      from '../Filter/FilterHelper.js';

const FILTER       = getDefaultFilter();
const GRID_ID      = 'cams-grid';
const defaultOrder = Flux.Constants.Vxql.Actors.Order.ONLINE_RANKING;
const FILTER_PARAM = 'filter';
const ORDER_PARAM  = 'order';
const PAGE         = CAMS;
import './../../../../src/VX/Asset/Less/VX/View/Cams.less';

const _SORTS = [
    {
        selected:    false,
        sort:        Flux.Constants.Vxql.Actors.Order.GUEST_PREFERENCES,
        text:        Translations.get('GuestProfileAssistantInterests'),
        subText:     Translations.get('common.ranking-by-preferences'),
        icon:        '-icon-pen-full',
        onIconClick: ({beforeSetSort}) => {
            openModalBox(ModalBoxEnum.ONBOARDING_CHOOSE, {overCookie: true}, () => {
                beforeSetSort(Flux.Constants.Vxql.Actors.Order.GUEST_PREFERENCES);
            });
        }
    },
    {
        selected: false,
        sort:     Flux.Constants.Vxql.Actors.Order.ONLINE_RANKING,
        text:     Translations.get('common.general-ranking'),
    },
];

const DEFAULT_SEO_STATE = {
    h1:            '',
    h2:            '',
    freeText:      '',
    freeTextShort: '',
    breadcrumb:    '',
    slug:          '',
};

function isOnboarding() {
    return VXConfig.guest?.showPreferencesFilter;
}

class Cams extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            showFilter:   false,
            filter:       getFilter(FILTER),
            activeFilter: getActiveFilter(structuredClone(FILTER)),
            isMobile:     Flux.Browser.isMobileView(),
            isTablet:     Flux.Browser.isTabletView(),
            total:        0,
            totalOnline:  0,
            order:        getOrderParam(ORDER_PARAM, defaultOrder, CAMS, isOnboarding()),
            loading:      true,
            key:          0,
            ...DEFAULT_SEO_STATE
        };

        this.breadcrumb  = {};
        this.scrollY     = 0;
        this.filterRef   = null;
        this.gridCompRef = null;

        this.onWindowResize        = this.onWindowResize.bind(this);
        this.onClickShowFilter     = this.onClickShowFilter.bind(this);
        this.onClickHideFilter     = this.onClickHideFilter.bind(this);
        this.onClickToggleFilter   = this.onClickToggleFilter.bind(this);
        this.onClickFilterTag      = this.onClickFilterTag.bind(this);
        this.resetFilter           = this.resetFilter.bind(this);
        this.onActorDataLoadChange = this.onActorDataLoadChange.bind(this);
        this.onActorDataChange     = this.onActorDataChange.bind(this);
        this.onSortChange          = this.onSortChange.bind(this);
        this.onBrowserNavigation   = this.onBrowserNavigation.bind(this);
        this.getBreadcrumb         = this.getBreadcrumb.bind(this);
    }

    componentDidMount() {
        window.scrollTo(0, 0);

        Flux.Actors.addActorsDataLoadListener(this.onActorDataLoadChange);
        Flux.Actors.addActorsDataChangeListener(this.onActorDataChange);
        Flux.Browser.addWindowResizeListener(this.onWindowResize);
        Flux.Browser.addWindowPopStateListener(this.onBrowserNavigation);
        getFilterFromUrl(this.props.isHomepage, FILTER_PARAM, this.state.filter, PAGE).then(data => {
            this.setState(data);
        });
    }

    componentWillUnmount() {
        Flux.Actors.removeActorsDataChangeListener(this.onActorDataChange);
        Flux.Actors.removeActorsDataLoadListener(this.onActorDataLoadChange);
        Flux.Browser.removeWindowResizeListener(this.onWindowResize);
        Flux.Browser.removeWindowPopStateListener(this.onBrowserNavigation);
    }

    onActorDataChange(id) {
        if (id !== GRID_ID) {
            return;
        }
        const total       = this.getActorsTotalFromStore();
        const totalOnline = this.getActorsTotalFromStore(true);
        this.setState({total, totalOnline});
    }

    onActorDataLoadChange() {
        const total       = this.getActorsTotalFromStore();
        const totalOnline = this.getActorsTotalFromStore(true);
        this.setState({total, totalOnline});
    }

    getActorsTotalFromStore(withOnline = false) {
        return Flux.Actors.getActorsTotalCount(generateModelsV3Filter(this.state.activeFilter, withOnline), this.state.order, '') || 0;
    }

    onWindowResize() {
        this.setState({isMobile: Flux.Browser.isMobileView(), isTablet: Flux.Browser.isTabletView()});
    }

    onBrowserNavigation() {
        getFilterFromUrl(this.props.isHomepage, FILTER_PARAM, this.state.filter, PAGE, FILTER).then(data => {
            this.setState(data);
        });
    }

    getBreadcrumb() {
        if (this.props.isHomepage) {
            return null;
        }


        const tags = [];
        this.state.activeFilter.map(item => {
                    if (item.type === 'tag') {
                        tags.push(item.tag);
                    }
                }
        );
        if (this.breadcrumb.slug !== this.state.breadcrumb) {
            this.breadcrumb = {
                slug: this.state.breadcrumb,
                comp: <Breadcrumb
                              breadcrumbType={Flux.Constants.Breadcrumb.CAMS}
                              breadcrumbData={{tags}}
                              breadcrumbKey={Flux.Constants.Breadcrumb.CAMS + '-' + JSON.stringify(tags)}
                      />
            };
        }

        return this.breadcrumb.comp;
    }

    onClickFilterTag(newFilter) {
        this.scrollY = 0;
        !this.state.isMobile && window.scrollTo({top: 0, behavior: 'smooth'});
        const filter       = setActiveFilterTags(this.state.filter, newFilter);
        const activeFilter = getActiveFilter(filter);
        const tags         = activeFilter.filter(tag => tag.type === 'tag').map(tag => tag.text);

        if (tags.length > 0) {
            getSeo(filter, activeFilter, tags, this.props.isHomepage, PAGE, FILTER_PARAM, true)
                    .then(seoData => {
                        this.setState(seoData);
                    });
        } else {
            const url = getBaseUrl(this.props.isHomepage, PAGE);
            window.history.pushState({}, "", url);
            this.setState({filter, activeFilter, ...DEFAULT_SEO_STATE});
            setFilterParam(activeFilter, FILTER_PARAM);
        }
    }


    onClickHideFilter() {
        this.state.isMobile && Flux.VXMobile.showNavigation(true);
        Flux.VXMobile.removeBodyOverflowHidden();
        window.scrollTo({top: this.scrollY});
        this.setState({showFilter: false});
    }

    onClickShowFilter() {
        this.state.isMobile && Flux.VXMobile.hideNavigation(true);
        this.scrollY = window.scrollY;
        Flux.VXMobile.addBodyOverflowHidden();
        this.setState({showFilter: true});
    }

    onClickToggleFilter(isFixed) {
        if (this.state.showFilter) {
            this.onClickHideFilter();
        } else {
            this.onClickShowFilter(isFixed);
        }
    }

    resetFilter(order = this.state.order) {
        this.setState({
            filter:       structuredClone(FILTER),
            activeFilter: getActiveFilter(structuredClone(FILTER)),
            order,
            key:          Math.random(), ...DEFAULT_SEO_STATE
        }, () => {
            window.history.pushState({}, "", getBaseUrl(this.props.isHomepage, PAGE));
            window.scrollTo({top: 0, behavior: 'smooth'});
        });
    }

    onSortChange(order) {
        this.resetFilter(order);
        setOrderParam(ORDER_PARAM, order);
    }

    render() {
        const {as: Tag} = this.props;
        const h2Key     = Flux.Browser.isSexole() ? 'seo_headlines.cams_collection_label_all_actors_h2--sexole' : 'seo_headlines.cams_collection_label_all_actors_h2';

        return <Tag className={"cams" + (this.props.isHomepage ? ' -homepage' : '')}>
            {this.getBreadcrumb()}
            <Headline class="vxheadline--medium"
                      title={this.state.h2 ? this.state.h2 : Translations.get(h2Key)}
                      quantity={{number: this.state.totalOnline, text: 'Online'}}
            >
                {isOnboarding() && <ExtendedSorter onSortChange={this.onSortChange} defaultSort={this.state.order} sorts={_SORTS} />}
            </Headline>
            {this.state.freeTextShort && <CamsSeoTeaser text={this.state.freeTextShort} />}
            <TopFilterContainer tags={getTopFilter(this.state.filter)}
                                onClickTag={this.onClickFilterTag}
                                activeFilterCount={getFilterCount(this.state.activeFilter)}
                                isMobile={this.state.isMobile}
                                onClickToggleFilter={this.onClickToggleFilter}
                                showFilter={this.state.showFilter}
                                compRef={this}
            />
            <div className={'cams__content' + (this.state.showFilter ? ' cams__content--filter' : '')}>
                <Filter filter={this.state.filter}
                        activeFilter={this.state.activeFilter}
                        resetFilter={this.resetFilter}
                        showFilter={this.state.showFilter}
                        isMobile={this.state.isMobile}
                        onClickHideFilter={this.onClickHideFilter}
                        onClickFilterTag={this.onClickFilterTag}
                        total={this.state.total}
                        ref={ref => this.filterRef = ref}
                        headline={"Cams"}
                />
                {!this.state.loading && <CamsGrid gridId={GRID_ID}
                                                  filter={this.state.activeFilter}
                                                  showFilter={this.state.showFilter}
                                                  order={this.state.order}
                                                  total={this.state.total}
                                                  isMobile={this.state.isMobile}
                                                  resetFilter={this.resetFilter}
                                                  isTablet={this.state.isTablet}
                                                  ref={ref => this.gridCompRef = ref}
                                                  key={this.state.key}
                />}
            </div>
            {this.state.freeText && <CamsSeoFooter text={this.state.freeText} />}
        </Tag>;
    }
}

Cams.propTypes = {
    as:         PropTypes.string,
    isMobile:   PropTypes.bool,
    isHomepage: PropTypes.bool
};

Cams.defaultProps = {
    as:         'div',
    isMobile:   true,
    isHomepage: false,
};

export default Cams;
